export let dataProps = {
    key: 0,
    id: 0,
    tax_name: '',
    tax_percent: 0,
    applicable_on_sale_invoice: true,
    gst_india: false,
    deductible: false,
    fixed: false,
    inter_state: 0,//0=inter state, 1= intra state
    tally_sub_group_id: null
}


// WEBPACK FOOTER //
// ./src/store/modules/taxSetting/properties.js